export default function Bdg({ t, bg, clr }) {
  return (
    <span className="px-2.5 py-[3px] rounded-full text-[10.5px] font-semibold shrink-0" style={{ background: bg, color: clr }}>
      {t}
    </span>
  );
}

